import { useState } from 'react';
import './SearchPage.css';
import Search from './Search';
import TickerInfo from './TickerInfo';
import NavBar from './NavBar';

function SearchPage() {
  const [results, setResults] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  
  const params = {
    results,
    setResults,
    searchQuery,
    setSearchQuery
  }

  return (
    <div className="Page">
      <div className='content'>
        <NavBar/>
        <Search params={params}/>
        {results && <TickerInfo params={params}/>}
        {/* <footer><a href="https://www.flaticon.com/free-icons/zodiac-sign" title="zodiac sign icons">Zodiac sign icons created by Marz Gallery - Flaticon</a></footer> */}
      </div>
    </div>
  );
}

export default SearchPage;
